import * as signalR from '@microsoft/signalr';
import global from '../utility/global';

class signalRBase {
    connection = null;
    params = null;
    joinGroups = false;
    mainMessage = 'Facture Soft SignalR';

    async init(params) {
        this.printLog("iniciando configuración...");
        this.params = params;

        if ([null, undefined, ''].includes(this.params.userName)) {
            this.printLog("centenario transmission  la propiedad 'userName' es obligatoria.", 2);
            return new Promise((_, reject) => reject(undefined));
        }

        if ([null, undefined, ''].includes(this.params.userGroup)) {
            this.printLog("centenario transmission  la propiedad 'userGroup' es obligatoria.", 2);
            return new Promise((_, reject) => reject(undefined));
        }

        if ([null, undefined, ''].includes(this.params.session)) {
            this.printLog("centenario transmission  la propiedad 'session' es obligatoria.", 2);
            return new Promise((_, reject) => reject(undefined));
        }

        if ([null, undefined, ''].includes(this.params.device)) {
            this.printLog("centenario transmission  la propiedad 'device' es obligatoria.", 2);
            return new Promise((_, reject) => reject(undefined));
        }

        if ([null, undefined, ''].includes(this.params.system)) {
            this.printLog("centenario transmission  la propiedad 'system' es obligatoria.", 2);
            return new Promise((_, reject) => reject(undefined));
        }

        if ([null, undefined, ''].includes(this.params.entity)) {
            this.printLog("centenario transmission  la propiedad 'entity' es obligatoria.", 2);
            return new Promise((_, reject) => reject(undefined));
        }

        if ([null, undefined, ''].includes(this.params.integrationCode)) {
            this.printLog("centenario transmission  la propiedad 'integrationCode' es obligatoria.", 2);
            return new Promise((_, reject) => reject(undefined));
        }

        if ([null, undefined].includes(this.connection)) {
            var obj = {
                p1: this.params.userName,
                p2: this.params.userGroup,
                p3: this.params.session,
                p4: this.params.device,
                p5: this.params.system,
                p6: this.params.entity,
                p7: this.params.integrationCode
            };
            this.printLog("configurando...", 1);
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(`${this.params.url}?${global.formatParameterV2(obj)}`)
                .configureLogging(signalR.LogLevel.Information)
                .withAutomaticReconnect({
                    nextRetryDelayInMilliseconds: retryContext => {
                        console.info(retryContext.elapsedMilliseconds);
                        if (retryContext.elapsedMilliseconds < 60000)
                            return 20000;
                        if (retryContext.elapsedMilliseconds < 300000)
                            return 10000;
                        if (retryContext.elapsedMilliseconds < 28800000)
                            return 15000;

                        return null;
                    }
                })
                .build();

            var connectionId = await this.start();

            return new Promise((resolve) => {
                resolve(connectionId);
            });
        }

        return new Promise((_, reject) => {
            reject(undefined);
        });
    };

    async start() {
        this.printLog("iniciando conexión...");
        var connectionId = undefined;

        await this.connection.start()
            .then(() => {
                this.printLog("conectado.");
                this.printLog(`connection_id: ${this.connection.connectionId}`);
                for (let index = 0; index < this.params.groups.length; index++) {
                    this.joinGroup(this.params.groups[index]);
                }
                connectionId = this.connection.connectionId;
            })
            .catch(error => {
                this.printLog("error iniciando conexión.", 2);
                console.error(error);
            });

        await this.connection.onreconnected(connectionId => {
            if (this.connection.state === signalR.HubConnectionState.Connected) {
                this.printLog(`connection_id: ${this.connection.connectionId}`);
                this.printLog("reconectado.");
                for (let index = 0; index < this.params.groups.length; index++) {
                    this.joinGroup(this.params.groups[index]);
                }
            }
            connectionId = this.connection.connectionId;
        });

        return connectionId;
    };

    joinGroup(group) {
        this.connection
            .invoke("join-group", group)
            .then(() => {
                this.printLog(`unión de grupo correctamente. | ${group}`);
                this.joinGroups = true;
            })
            .catch(error => {
                this.printLog("error uniendo grupos.", 2);
                console.error(error);
                this.joinGroups = false;
            });
    };

    sendMessageGroup(eventName, message) {
        for (let index = 0; index < this.params.groups.length; index++) {
            this.connection
                .invoke("send-message-group", this.params.groups[0], eventName, message)
                .then(() => {
                    this.printLog(`mensaje enviado correctamente.`);
                })
                .catch(error => {
                    this.printLog("error enviando el mensaje.", 2);
                    console.error(error);
                });
        }
    };

    close() {
        this.connection
            .stop()
            .then(response => {
                this.printLog("conexión cerrada", 1);
                this.connection = null;
            })
            .catch(error => {
                this.printLog("error cerrando conexión", 2);
                this.connection = null;
            });
    };

    on(event_name, action) {
        try {
            this.printLog("1. quitando asignación de evento...");
            this.connection.off(event_name);

            this.printLog(`2. asignando evento... | ${event_name}`);
            this.connection.on(event_name, action);

            this.printLog("3. asignación de evento finalizada.");
        } catch (error) {
            let timer = setInterval(() => {
                try {
                    this.printLog("1. reitentando asignación de evento.");
                    this.printLog("2. quitando asignación de evento...");
                    this.connection.off(event_name);

                    this.printLog(`3. asignando evento... | ${event_name}`);
                    this.connection.on(event_name, action);

                    this.printLog("4. asignación de evento finalizada.");
                    clearTimeout(timer);
                } catch (error) {
                    this.printLog("1. error asignación evento.", 2);
                    this.printLog("2. reintentando en los proximos 5 segundos.", 2);
                }
            }, 5000);
        }
    };

    off(event_name) {
        try {
            this.printLog("1. quitando asignación de tarea...");
            this.connection.off(event_name);

            this.printLog("2. asignación de tarea finalizada.");
        } catch (error) {
            let timer = setInterval(() => {
                try {
                    this.printLog("1. reitentando asignación de tarea.");
                    this.printLog("2. quitando asignación de tarea...");
                    this.connection.off(event_name);

                    this.printLog("3. asignación de tarea finalizada.");
                    clearTimeout(timer);
                } catch (error) {
                    this.printLog("1. error quitando asignación tarea.", 2);
                    this.printLog("2. reintentando en los proximos 5 segundos.", 2);
                }
            }, 5000);
        }
    };

    printLog(message, type = 1) {
        if (type === 1)
            console.info(`${this.mainMessage} | ${message}`);
        else
            console.error(`${this.mainMessage} | ${message}`);
    };
}
export default new signalRBase();